import "./add.css"
import './details.css'
import { useState, useEffect, useContext } from "react";
import { Button, Space, message } from "antd";
import { useNavigate, useParams } from 'react-router-dom';
import { EditOutlined, PlusOutlined, DeleteOutlined, PrinterOutlined } from '@ant-design/icons';
import { Item, ItemService, tableDoDontSchema, tableSchema } from '../../services/Item';
import { USER_ROLES, getCurrentUser } from "../../services/User";
import ProcessFlow from "../processFlow/processFlow";
import TableDetailsWrapper from "./tableDetails/tableDetailsWrapper";
import QuillEditorReadOnly from "../quillEditor/quillEditorReadOnly";
import ScrollToTopButton from "./scrollToTopButton/scrollToTopButton";
import TableDetails from "./tableDetails/tableDetails";
import { getTableColumns, TABLE_DO_DONT_COLUMNS } from "./tableDetails/tableColumns";
import { ItemsContext } from "../../layout/itemContext/itemContext";


function ItemDetails() {

    const navigate = useNavigate();
    const params = useParams();
    const user = getCurrentUser();
    const [item, setItem] = useState<Item>();
    const { getTitles } = useContext(ItemsContext);

    useEffect(() => {
        if (params.id) {
            getItem(params.id)
        } else {
            setItem(undefined);

        }

    }, [params.id])

    const getItem = async (_id: string) => {
        const { data } = await ItemService.getById(_id, true);
        setItem(data)
    }

    const addSubtitle = () => {
        navigate(`/${params.country}/add`, { state: { parent: item?._id, hasParent: true, itemType: item?.itemType } })
    };

    const editSubtitle = () => {
        navigate(`/${params.country}/edit/${item?._id}`)
    };

    const deleteItem = async () => {
        if (item?.children.length) {
            message.warning("When you delete all subtitles, you will be able to delete this item")
        } else {
            await ItemService.delete(item?._id!);
            message.success("Successfully deleted!")
            await getTitles(true);
        }
    }

    const printDetails = () => {
        window.print();
    }

    const canEdit = (user.role === USER_ROLES.ADMIN_COUNTRY || user.role === USER_ROLES.ADMIN) && params.country === user.country

   
    return (
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h1>{item?.title}</h1>
                <Space className="no-print">
                    { canEdit === true && <>
                        {!item?.parent && <Button type="primary" onClick={addSubtitle} icon={<PlusOutlined />}>
                            Add Subsection
                        </Button>}
                        <Button type="primary" onClick={editSubtitle} icon={<EditOutlined />}>
                            Edit
                        </Button>
                        {/* <Popconfirm
                        title='Delete item'
                        description="Are you sure you want to delete this item?"
                        onConfirm={deleteItem}
                        cancelText="Cancel"
                    > */}
                        <Button type="primary" icon={<DeleteOutlined />} onClick={deleteItem}>
                            Delete
                        </Button>
                        {/* </Popconfirm> */}
                    </>
                    }
                    <Button type="primary" icon={<PrinterOutlined />} onClick={printDetails}>Print Section</Button>
                </Space>
            </div>
            
            {item?.itemType === 'content' && <>
                <QuillEditorReadOnly item={item} />
                <TableDetails<tableSchema> dataSource={item.tableContent || []}  columns={getTableColumns(1)} title=''/>
                <TableDetails<tableDoDontSchema> dataSource={item.tableDoDont || []}  columns={TABLE_DO_DONT_COLUMNS} title={item?.titleDoDont || ''}/>
            </>}
            {item?.itemType === 'table' && <div>
                <TableDetailsWrapper item={item} />
                <ProcessFlow item={item}/>
            </div>
            }
            <span className="no-print">
                <ScrollToTopButton/>
            </span>
        </div>

    );
}

export default ItemDetails;